import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { forwardRef } from 'react';

export const CircularIcon = forwardRef<SVGSVGElement, SvgWrapperProps>(
  (props, ref) => (
    <SvgWrapper fill='none' ref={ref} viewBox='0 0 16 16' {...props}>
      <circle cx='1.5' cy='9.5' r='1.5' fill='currentColor' />
      <path
        d='M14.5 10.5L10.5 14.5H5.5L1.5 9.5L3.5 3.5L8.5 1.5L13.5 4.5'
        stroke='currentColor'
      />
      <circle cx='3.5' cy='3.5' r='1.5' fill='currentColor' />
      <circle cx='8.5' cy='1.5' r='1.5' fill='currentColor' />
      <circle cx='13.5' cy='4.5' r='1.5' fill='currentColor' />
      <circle cx='14.5' cy='10.5' r='1.5' fill='currentColor' />
      <circle cx='5.5' cy='14.5' r='1.5' fill='currentColor' />
      <circle cx='10.5' cy='14.5' r='1.5' fill='currentColor' />
    </SvgWrapper>
  ),
);

CircularIcon.displayName = 'CircularIcon';
